<template>
    <hr
        class="ds-divider"
        :class="{ 'is-vertical': isVertical, 'is-dark': theme === 'dark', 'is-stack-medium': isStackMedium }"
    />
</template>

<script lang="ts" setup>
import type { Theme } from "../types/theme";

withDefaults(
    defineProps<{
        /**
         * Set vertical mode
         */
        isVertical?: boolean;
        /**
         * Set theme
         */
        theme?: Theme;
        /**
         * Set flag whether use medium stack around divider
         */
        isStackMedium?: boolean;
    }>(),
    {
        isVertical: false,
        theme: "light",
        isStackMedium: false,
    }
);
</script>
